module.exports = __webpack_public_path__ + "static/media/rejected-file-grey.d1730c42.svg";